import { Outlet, useParams } from 'react-router-dom'
import useSWR from 'swr'

import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import UserList from './UserList'

/** 用户管理：左侧真人列表，右侧为选中用户的权限配置 */
const UsersPage = () => {
  const { id } = useParams()
  const { data: users } = useSWR(['/users'])
  const humans = users?.filter((u) => u.kind !== 'bot')

  return (
    <div className="flex flex-col gap-4 md:flex-row">
      <Card className="md:w-1/4 lg:w-1/5">
        <CardHeader>
          <CardTitle className="text-base">用户</CardTitle>
        </CardHeader>
        <CardContent>
          <UserList users={humans} emptyText="暂无用户" />
        </CardContent>
      </Card>
      <div className="flex-1 min-w-0">
        {id ? (
          <Outlet />
        ) : (
          <p className="p-4 text-sm text-muted-foreground">
            从左侧选择一个用户查看和配置权限。
          </p>
        )}
      </div>
    </div>
  )
}

export default UsersPage
